import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/layout/Header';
import { BuildTabs } from '@/components/build';

const Items = () => {
  const [searchParams] = useSearchParams();
  const projectParam = searchParams.get('project');
  const anchorParam = searchParams.get('anchor');

  useEffect(() => {
    if (projectParam && anchorParam) {
      if (import.meta.env.DEV) {
        console.debug('[Items] Navigation params:', { project: projectParam, anchor: anchorParam });
      }
      // The ItemsManagement component will handle these params via props
    }
  }, [projectParam, anchorParam]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto py-6 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Build Management</h1>
          <p className="text-muted-foreground">
            Quản lý tiến độ Build theo ngày trong khung thời gian T-1 → T+5 tháng
          </p>
        </div>
        <BuildTabs 
          initialProject={projectParam || undefined}
          initialAnchor={anchorParam || undefined}
        />
      </main>
    </div>
  );
};

export default Items;